import { render } from "./Acordeon.vue?vue&type=template&id=da1f2d12&ts=true"
import script from "./Acordeon.vue?vue&type=script&lang=ts"
export * from "./Acordeon.vue?vue&type=script&lang=ts"

import "./Acordeon.vue?vue&type=style&index=0&id=da1f2d12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__